import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { formatDateString } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["packing-slip-printed-at"];

export const PackingSlipPrintedAtColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  title: catalogEntry.title,
  key: catalogEntry.key,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    return (
      <RedoTableTextCell
        subtext={row.printStatus?.packingSlipPrintedAt?.toLocaleTimeString(
          undefined,
          { hour: "numeric", minute: "numeric", hour12: true },
        )}
        text={formatDateString(
          row.printStatus?.packingSlipPrintedAt?.toISOString(),
        )}
      />
    );
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
